// Returns the dashboard home URL for the current practice.
// All practices → /dashboard/app (the Launchpad renders for every practice —
// no URL distinction needed).
//
// Use this hook anywhere you'd otherwise hardcode `navigate('/dashboard/app')`
// so navigations stay on the Dashboard page for all practice types.

import { PATH_DASHBOARD } from 'src/routes/paths';

export default function useDashboardHomePath() {
    return PATH_DASHBOARD.general.app;
}
